// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"89":"testimonials-section","130":"featured-products"}[chunkId] || chunkId) + "." + {"89":"e2043d8d","130":"bdd4446e","405":"ac546ad9","535":"d4ddb547"}[chunkId] + ".chunk.css";
};